import { Directive, ElementRef, Input, OnInit, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { EnvironmentService } from '@mwe/services';

@Directive({ selector: '[mweEnvTranslate]' })
export class EnvTranslateDirective implements OnInit {
  private translateService = inject(TranslateService);
  private elementRef = inject(ElementRef);
  private environmentService = inject(EnvironmentService);

  @Input() mweEnvTranslate: string;

  ngOnInit(): void {
    const label = `${this.mweEnvTranslate}.${this.environmentService.getPortalCustomerType()}`;
    const translation = this.translateService.instant(label);
    this.elementRef.nativeElement.innerText = translation;
  }
}
